module.exports = __webpack_public_path__ + "img/ADDITIONAL_ACTIVITY.24b15328.webp";